
export default function ServicesProcess() {
  const processSteps = [
    {
      step: '01',
      title: 'お問い合わせ・ヒアリング',
      description: 'お客様のご要望や課題について詳しくお聞かせください。現地調査のご相談も承ります。',
      icon: 'ri-phone-line',
      color: 'bg-blue-500'
    },
    {
      step: '02',
      title: '現地調査・診断',
      description: '専門スタッフが現地を訪問し、建物の状況を詳細に調査・診断いたします。',
      icon: 'ri-search-line',
      color: 'bg-green-500'
    },
    {
      step: '03',
      title: '提案・お見積り',
      description: '調査結果を基に、最適なソリューションと詳細なお見積りをご提案いたします。',
      icon: 'ri-file-list-line',
      color: 'bg-orange-500'
    },
    {
      step: '04',
      title: 'ご契約・着手',
      description: 'ご契約後、プロジェクト管理者を配置し、計画的に作業を進めてまいります。',
      icon: 'ri-handshake-line',
      color: 'bg-purple-500'
    },
    {
      step: '05',
      title: '施工・管理',
      description: '経験豊富な職人と最新の技術で、高品質な施工をお約束いたします。',
      icon: 'ri-tools-line',
      color: 'bg-red-500'
    },
    {
      step: '06',
      title: '完了・アフターケア',
      description: 'お引き渡し後も継続的なサポートで、長期的な満足をお約束いたします。',
      icon: 'ri-customer-service-line',
      color: 'bg-teal-500'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            サービスの流れ
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            お問い合わせから完了まで、お客様に安心していただける丁寧なプロセスで対応いたします
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {processSteps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
                <div className="flex items-center mb-6">
                  <div className={`${step.color} text-white p-3 rounded-lg mr-4`}>
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className={`${step.icon} text-xl text-white`}></i>
                    </div>
                  </div>
                  <div className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-sm font-semibold">
                    STEP {step.step}
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {step.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              
              {/* Connection line for desktop */}
              {index < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-16 -right-4 w-8 h-0.5 bg-gray-300 z-10"></div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-blue-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              お客様のご要望に応じて柔軟に対応
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              緊急時の対応や特殊な案件についても、豊富な経験とネットワークを活かして最適なソリューションをご提供いたします。
              まずはお気軽にご相談ください。
            </p>
            <div className="flex items-center justify-center space-x-6 text-sm text-gray-500">
              <div className="flex items-center">
                <div className="w-4 h-4 flex items-center justify-center mr-2">
                  <i className="ri-time-line text-green-500"></i>
                </div>
                24時間緊急対応
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 flex items-center justify-center mr-2">
                  <i className="ri-shield-check-line text-green-500"></i>
                </div>
                品質保証付き
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 flex items-center justify-center mr-2">
                  <i className="ri-customer-service-2-line text-green-500"></i>
                </div>
                アフターサポート
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
